import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { BottomNavigation, BottomNavigationAction, CssBaseline, Button, Badge } from '@material-ui/core';
import {Home, ShoppingCart, People} from '@material-ui/icons';
import {isMobileOnly, CustomView , isMobile} from 'react-device-detect';

const barWidth = () => {
  if (isMobile) return '100vw'
  else return '70vw'
}

const useStyles = makeStyles({

    ContentBackground:{
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#282c34',
      height: '7vh',
      display: 'flex',
      width:'100vw',
      verticalAlign: 'middle',
      flexDirectison: 'columns',
      position: 'sticky',
      bottom:'0px'
    },

    root: {
      width: barWidth(),
      color: 'whitesmoke'
    },
  });
  

function Botnavi({value, onChange, cartEmpty, onCheckOut, numberCart}) {

    const classes = useStyles();
    return (
  
      <div className = {classes.ContentBackground}> 
          
          <BottomNavigation value={value} onChange={(event,tab) => {event.preventDefault(); onChange(tab)}} className={classes.root}>
            <BottomNavigationAction label="Home" icon = {<Home/>}/>
            
            <BottomNavigationAction label="Cart" icon = {
              <Badge badgeContent={numberCart} color="secondary">
              <ShoppingCart/>
              </Badge>
            }/>
            
            <BottomNavigationAction label="Profile" icon = {<People/>}/>
            <CustomView condition = {value === 1 && !cartEmpty} style = {{display: 'inherit'}}> 
                <Button onClick = {onCheckOut(true)} color = 'secondary' variant = 'contained'>Check Out</Button>
            </CustomView>
          </BottomNavigation>
        <CssBaseline/>
      </div>
    );
}

export default Botnavi;